import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../component/layout';

import WaterMetersTab from './water_meters';
import TransactionsTab from './transactions';
import AccountsTab from './accounts';

function WaterMeterManagement() {
    const [activeTab, setActiveTab] = useState('water-meters');
    
    return (
        <Layout>
            <div className="page-header">
                <div className="page-block">
                    <div className="row align-items-center">
                        <div className="col-md-12">
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to={"/facility/"}>Dashboard</Link>
                                </li>
                                <li className="breadcrumb-item">
                                    <Link to={"/facility/water_management"}>
                                        Water Management
                                    </Link>
                                </li>
                                <li className="breadcrumb-item active">
                                    Water Meter Management
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-sm-12">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="card">
                                                <div className="card-body py-0">
                                                    <ul className="nav nav-tabs profile-tabs">
                                                        <li className="nav-item">
                                                            <button
                                                                className={`nav-link ${activeTab === 'water-meters' ? 'active' : ''}`}
                                                                onClick={() => setActiveTab('water-meters')}
                                                                type="button"
                                                            >
                                                                <i className="ti ti-device-analytics me-2"></i>Water Meters
                                                            </button>
                                                        </li>
                                                        <li className="nav-item">
                                                            <button
                                                                className={`nav-link ${activeTab === 'transactions' ? 'active' : ''}`}
                                                                onClick={() => setActiveTab('transactions')}
                                                                type="button"
                                                            >
                                                                <i className="ti ti-receipt me-2"></i>Transactions
                                                            </button>
                                                        </li>
                                                        <li className="nav-item">
                                                            <button
                                                                className={`nav-link ${activeTab === 'accounts' ? 'active' : ''}`}
                                                                onClick={() => setActiveTab('accounts')}
                                                                type="button"
                                                            >
                                                                <i className="ti ti-users me-2"></i>Accounts
                                                            </button>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>

                                            <div className="tab-content" style={{ paddingTop: '1rem' }}>
                                                {activeTab === 'water-meters' && (
                                                    <WaterMetersTab />
                                                )}
                                                {activeTab === 'transactions' && (
                                                    <TransactionsTab />
                                                )}
                                                {activeTab === 'accounts' && (
                                                    <AccountsTab />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
}

export default WaterMeterManagement;